import styled from "@emotion/styled"
import Link from "components/Link"

const CTAFormLink = styled(Link)`
  color: ${({ theme }) => theme.palette.common.black};
`

export default CTAFormLink
